// Traduções da faixa de indicadores — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'resumoBanner.total': 'Total',
    'resumoBanner.semSituacao': 'Sem situação',
    'resumoBanner.atualizadoEm': 'Última alteração',
  },
  en: {
    'resumoBanner.total': 'Total',
    'resumoBanner.semSituacao': 'No status',
    'resumoBanner.atualizadoEm': 'Last change',
  },
  es: {
    'resumoBanner.total': 'Total',
    'resumoBanner.semSituacao': 'Sin situación',
    'resumoBanner.atualizadoEm': 'Última modificación',
  },
}
